import * as React from 'react';
import { createRoot } from 'react-dom/client';
import { Toaster } from 'react-hot-toast';
import { showToast } from './utils/toast.util';

const TOASTER_ROOT_ID = 'rht-toaster-root';

export function mountToaster() {
  if (typeof document === 'undefined') {
    return;
  }

  (window as unknown as { showToast: typeof showToast }).showToast = showToast;

  if (document.getElementById(TOASTER_ROOT_ID)) {
    return;
  }

  const container = document.createElement('div');
  container.id = TOASTER_ROOT_ID;
  document.body.appendChild(container);

  createRoot(container).render(<Toaster position="bottom-center" />);
}
